export default {
    clientTabs: [/*{
            label: "SSR",
            name: "first"
        },
        {
            label: "SS/SSD",
            name: "second"
        },*/
        {
            label: "V2RAY",
            name: "third"
        }
    ],
    clientType: [{
            value: "option1",
            label: "Windows"
        },
        {
            value: "option2",
            label: "macOS"
        },
        {
            value: "option3",
            label: "Linux (GUI)"
        },
        {
            value: "option4",
            label: "Android"
        },
        {
            value: "option5",
            label: "iOS"
        },
        {
            value: "option6",
            label: "路由器"
        }
    ]
}
